import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodDto, PaymentMethodMetaModel } from '@well/company-libs/payment-method/domain-model';
import { SubscriptionCardViewWrapperComponent } from '@well/subscription-management';
import { PaymentMethodInputsComponent } from '../payment-method-inputs/payment-method-inputs.component';
import { JsonApiResource } from '@irian-ro/abstract-resource';

@Component({
  selector: 'well-choose-payment-method',
  standalone: true,
  imports: [CommonModule, SubscriptionCardViewWrapperComponent, PaymentMethodInputsComponent],
  templateUrl: './choose-payment-method.component.html',
  styleUrls: ['./choose-payment-method.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChoosePaymentMethodComponent {

  @Input() paymentMethodTemplate: JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel> | null = null;

  @Input() showTermsAndConditions = false;

  @Output() save: EventEmitter<PaymentMethodDto> = new EventEmitter<PaymentMethodDto>();
  model: PaymentMethodDto = new PaymentMethodDto();

  onSave(event: PaymentMethodDto){
    this.save.emit(event);
  }
}
